// landing-url.ts — public landing-site origin for outbound links (install guides, etc.).
// Env-aware so the dev dashboard (app-dev) links to the dev landing (dev.embent.com) where
// unreleased pages already exist, instead of hard-coding production. Same pattern as
// `embed-snippet.ts`: build-time VITE_ var from `apps/dashboard/.env` / CF Pages, with a
// production fallback so an unset var still yields working links.
export function landingUrl(): string {
  return (
    ((import.meta.env.VITE_LANDING_URL as string | undefined) ?? '').trim() ||
    'https://embent.com'
  );
}
